import styles from './styles.scss';
import { rm } from 'utils';
import { splitTitle } from 'components/Shared/Product/selector';
import { ProductProperties } from '../../../usp/productProperties';
import { NotifyLink } from 'components/Shared/NotifyLink';

export interface OwnProps {
  image: JSX.Element;
  price: JSX.Element;
  energyInformation: JSX.Element;
  review: JSX.Element;
  deliveryInformation: JSX.Element;
  fullTitle: string;
  titleSplitPos: number;
  url: string;
  ticket: string;
  usps?: string[];
}

export const Hero = ({
  image,
  price,
  fullTitle,
  titleSplitPos,
  energyInformation,
  review,
  deliveryInformation,
  url,
  ticket,
  usps
}: OwnProps) => {
  const { title, category } = splitTitle({
    title: fullTitle,
    titleSplitPos: titleSplitPos
  });

  return (
    <div className={styles.base}>
      <div className={styles.recommend_title}>
        <h3>{rm('campaignflag_type_werecommend')}</h3>
      </div>
      <div className={styles.frame}>
        <div className={styles.image}>{image}</div>
        <div className={styles.productinformation}>
          <NotifyLink url={url} ticket={ticket}>
            {category && <div className={styles.product_category}>{category}</div>}
            <div className={styles.product_title}>{title}</div>
          </NotifyLink>
          {price}
          {energyInformation}
          {review}
          <ProductProperties props={usps} />
          {deliveryInformation}
        </div>
      </div>
    </div>
  );
};
